module.exports = __webpack_public_path__ + "media/npc_dota_hero_phoenix.7ecc8e4e.webm";